import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/Header.gif";
import {
  ArrowRightCircle,
  Download,
  Linkedin,
  Github,
  Diagram3Fill,
} from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import React from "react";

export const Home = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const toRotate = ["Web Developer", "Web Designer", "UI/UX Designer"];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500);
    }
  };

  const socialLinks = [
    {
      href: "https://www.linkedin.com/in/sachin-saurabh/",
      icon: <Linkedin size={30} color={"rgba(170, 54, 124)"} />,
    },
    {
      href: "https://github.com/RaviSachinCodingLife",
      icon: <Github size={30} color={"rgba(170, 54, 124)"} />,
    },
    {
      href: "https://linktr.ee/ravicodinglife",
      icon: <Diagram3Fill size={30} color={"rgba(170, 54, 124)"} />,
    },
  ];

  const buttonStyles = {
    common: {
      borderRadius: "25px",
      padding: "10px 20px",
      lineHeight: "normal",
      boxSizing: "border-box",
      outline: "none",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    connect: {
      border: "1px solid rgba(170, 54, 124)",
      background: "transparent",
    },
    resume: {
      border: "1px solid rgba(170, 54, 124, 0.8)",
      background:
        "linear-gradient(90.21deg, rgba(170, 54, 124, 0.5) -5.91%, rgba(74, 47, 189, 0.5) 111.58%)",
    },
    portfolio3D: {
      border: "1px solid rgba(170, 54, 124, 0.8)",
      background:
        "linear-gradient(90.21deg, rgba(74, 47, 189, 0.5) -5.91%, rgba(170, 54, 124, 0.5) 111.58%)",
    },
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h1>
                    {`Hello,`} <br />
                    {`This is `}
                    <span style={{ color: "rgba(170, 54, 124)" }}>
                      {"Sachin Saurabh"}
                    </span>
                    <br />
                    {`I'm a Professional `}
                    <span style={{ color: "rgb(22 242 179" }}>
                      {"Software Engineer"}
                    </span>
                    <br />
                    <span
                      className="txt-rotate"
                      dataPeriod="1000"
                      data-rotate='[ "Frontend Developer", "Web Designer", "UI Designer","React Developer","2 Year Experience","Ex- @MSBC Group","Ex- @Neurosynaptic Communications" ]'
                    >
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>

                  <div
                    className="socialApp"
                    style={{ display: "flex", gap: "10px", padding: "10px" }}
                  >
                    {socialLinks.map((link, index) => (
                      <a
                        key={index}
                        role="button"
                        href={link.href}
                        style={{
                          transition: "transform 0.3s ease, filter 0.3s ease",
                        }}
                      >
                        {link.icon}
                      </a>
                    ))}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      paddingTop: "10px",
                    }}
                  >
                    {/* Top Row Buttons */}
                    <div
                      style={{
                        display: "flex",
                        gap: "15px",
                        alignItems: "center",
                      }}
                    >
                      <a
                        role="button"
                        href="#connect"
                        style={{ textDecoration: "none", outline: "none" }}
                      >
                        <button
                          style={{
                            ...buttonStyles.common,
                            ...buttonStyles.connect,
                          }}
                        >
                          Let’s Connect <ArrowRightCircle size={25} />
                        </button>
                      </a>

                      <a
                        role="button"
                        target="_blank"
                        href="https://drive.google.com/file/d/1605r2bY4v2vITol5oWm4siQRgobuXfDO/view"
                        style={{ textDecoration: "none", outline: "none" }}
                      >
                        <button
                          style={{
                            ...buttonStyles.common,
                            ...buttonStyles.resume,
                          }}
                        >
                          Get Resume <Download size={25} />
                        </button>
                      </a>
                    </div>

                    <a
                      role="button"
                      target="_blank"
                      href="https://3-d-portfolio-tau-blue.vercel.app/"
                      style={{
                        textDecoration: "none",
                        outline: "none",
                        alignSelf: "flex-start",
                      }}
                    >
                      <button
                        style={{
                          ...buttonStyles.common,
                          ...buttonStyles.portfolio3D,
                        }}
                      >
                        3D Portfolio <Diagram3Fill size={25} />
                      </button>
                    </a>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                >
                  <img src={headerImg} alt="Header Img" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
